import { createSlice } from "@reduxjs/toolkit";

export const breadCrumbsSlice = createSlice({
  name: "breadCrumbs",
  initialState: {
    value: [],
  },
  reducers: {
    update: (state, data) => {
      state.value = data.payload;
    },
  },
});

export const { update } = breadCrumbsSlice.actions;

export default breadCrumbsSlice.reducer;
